import { IFormRegisterResult, IFormRegisterResultVm } from "../../../models/response/form/IFormRegisterResult";
import { IFormBaseItemRequest } from "../../../models/request/form/IFormBaseItemRequest";

import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { IFormResultRequest } from "../../../models/request/form/IFormResultRequest";
import { IFormRegisterAttendanceRequest } from "../../../models/request/form/IFormRegisterAttendanceRequest";
export const objFormRegisterResultDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as IFormRegisterResult[],
    LOAD_ERROR: "",
    LOAD_COSO_CHIENDICH_START: {} as IFormBaseItemRequest,
    LOAD_COSO_CHIENDICH_SUCCESS: [] as IFormRegisterResultVm[],
    LOAD_COSO_CHIENDICH_ERROR: "",
    SHOW_EDIT_MODAL: {} as IFormRegisterResult | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IFormRegisterResult,
    SAVE_SUCESS: {} as IFormRegisterResult,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: "",
    UPDATE_INVITE_START: {} as IFormResultRequest,
    UPDATE_INVITE_SUCESS: undefined,
    UPDATE_INVITE_ERROR: "",
    UPDATE_RESULT_START: {} as IFormResultRequest,
    UPDATE_RESULT_SUCESS: undefined,
    UPDATE_RESULT_ERROR: "",
    UPDATE_HOCSINH_START: {} as IFormResultRequest,
    UPDATE_HOCSINH_SUCESS: undefined,
    UPDATE_HOCSINH_ERROR: "",
    UPDATE_STATUS_START: {} as IFormResultRequest,
    UPDATE_STATUS_SUCESS: undefined,
    UPDATE_STATUS_ERROR: "",
    SAVE_ATTENDANCE_START: {} as IFormRegisterAttendanceRequest,
    SAVE_ATTENDANCE_SUCESS: undefined,
    SAVE_ATTENDANCE_ERROR: "",
};

export const eFormRegisterResultActionTypeIds = generateActionTypeIds(objFormRegisterResultDefine, "FORM_REGISTER_RESULT")
export type IFormRegisterResultActionTypes = IGenericActionType<typeof objFormRegisterResultDefine, "FORM_REGISTER_RESULT">
